import { createStyles, makeStyles, Theme } from '@material-ui/core'

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    '@keyframes fadeInUp': {
      from: { opacity: 0, transform: 'translateY(8px)' },
      to: { opacity: 1, transform: 'translateY(0)' }
    },
    '@keyframes shimmer': {
      from: { backgroundPosition: '200% 0' },
      to: { backgroundPosition: '-200% 0' }
    },
    '@keyframes pulse': {
      '0%, 100%': { opacity: 1, transform: 'scale(1)' },
      '50%': { opacity: 0.35, transform: 'scale(0.8)' }
    },
    root: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: theme.spacing(4),
      width: '100%'
    },
    currentBatchCard: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(2),
      width: '100%',
      maxWidth: 560,
      padding: theme.spacing(3),
      backgroundColor: theme.palette.background.paper,
      border: `1px solid ${theme.palette.divider}`,
      borderRadius: theme.shape.borderRadius,
      boxShadow: theme.shadows[2],
      animation: '$fadeInUp 400ms ease-out',
      '@media (prefers-reduced-motion: reduce)': {
        animation: 'none'
      }
    },
    currentBatchHeader: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: theme.spacing(2)
    },
    statusLabel: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(1)
    },
    statusDot: {
      width: theme.spacing(1),
      height: theme.spacing(1),
      borderRadius: '50%',
      backgroundColor: theme.palette.primary.main,
      animation: '$pulse 1.4s ease-in-out infinite',
      '@media (prefers-reduced-motion: reduce)': {
        animation: 'none'
      }
    },
    progressRow: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(2)
    },
    progressBar: {
      flexGrow: 1,
      height: theme.spacing(1.5),
      borderRadius: theme.spacing(1),
      '& .MuiLinearProgress-bar': {
        borderRadius: theme.spacing(1),
        backgroundImage: `linear-gradient(90deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.light} 50%, ${theme.palette.primary.main} 100%)`,
        backgroundSize: '200% 100%',
        animation: '$shimmer 2.2s linear infinite',
        '@media (prefers-reduced-motion: reduce)': {
          animation: 'none'
        }
      }
    },
    progressValue: {
      minWidth: theme.spacing(6),
      textAlign: 'right',
      fontWeight: 500
    },
    batchDates: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'flex-start',
      columnGap: theme.spacing(4),
      rowGap: theme.spacing(1)
    },
    batchDateRow: {
      display: 'flex',
      alignItems: 'center'
    },
    batchDateIcon: {
      marginRight: theme.spacing(1),
      color: theme.palette.text.secondary
    },
    batchDateLabel: {
      fontWeight: 500
    },
    batchDateValue: {
      fontWeight: 400
    },
    otherBatchesSection: {
      width: '100%',
      // La tabla renderiza el contenedor de acciones aunque visibleIf oculte todos los botones
      // (lotes Solicitados) y en hover se vería una píldora vacía
      '& div#actions-column:empty': {
        display: 'none !important'
      }
    }
  })
)
